import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faTrash } from "@fortawesome/free-solid-svg-icons";
import Fire from "../api/Fire";
import CartContext from "../contexts/cart";
import Dialog from "./Dialog";

const CartItem = ({ item }) => {
  const { t } = useTranslation();
  const { cart } = useContext(CartContext);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(1);

  const _addToCart = async () => {
    let list = [...cart];
    let objIndex = list.findIndex((obj) => obj.id === item.id);
    if (list[objIndex].quantity === item.maxQuantity) {
      setType(2);
      setMessage(t("maxQuantity"));
      setVisible(true);
    } else {
      let q = item.type === "kilos" ? list[objIndex].quantity + 0.5 : list[objIndex].quantity + 1;
      list[objIndex].quantity = parseFloat(q);
      await Fire._updateCart({ items: list });
    }
  };

  const _removeFromCart = async () => {
    let list = [...cart];
    let objIndex = list.findIndex((obj) => obj.id === item.id);

    if (
      (list[objIndex].quantity === 1 && item.type !== "kilos") ||
      (list[objIndex].quantity === 0.5 && item.type === "kilos")
    ) {
      list.splice(objIndex, 1);
    } else {
      let q = item.type === "kilos" ? list[objIndex].quantity - 0.5 : list[objIndex].quantity - 1;
      list[objIndex].quantity = parseFloat(q);
    }
    await Fire._updateCart({ items: list });
  };

  const _deleteFromCart = async () => {
    let list = [...cart];
    let objIndex = list.findIndex((obj) => obj.id === item.id);
    list.splice(objIndex, 1);
    await Fire._updateCart({ items: list });
  };

  const _renderOptions = () => {
    return (
      <div className="d-flex align-items-center">
        <div className="d-flex justify-content-start align-items-center flex-fill">
          <button className="btn btn-success py-0 px-2 mx-1" onClick={_addToCart}>
            <FontAwesomeIcon icon={faPlus} size="sm" color="fff" />
          </button>

          <div className="p-2">{item.type === "kilos" ? item.quantity + " KG" : item.quantity}</div>

          <button className="btn btn-danger  py-0 px-2 mx-1" onClick={_removeFromCart}>
            <FontAwesomeIcon
              icon={
                (item.quantity === 1 && item.type !== "kilos") || (item.quantity === 0.5 && item.type === "kilos")
                  ? faTrash
                  : faMinus
              }
              size="sm"
              color="fff"
            />
          </button>
        </div>

        <FontAwesomeIcon className="hoverable" icon={faTrash} size="1x" color="red" onClick={_deleteFromCart} />
      </div>
    );
  };

  return (
    <div className="rounded p-3 border-bottom">
      <div className="d-flex">
        <div className="mb-3">
          <img src={item.image || item.thumbnail} alt={item.nameEn} height={50} width={50} />
        </div>

        <div className="flex-fill mx-3">
          <div className="d-flex">
            <div className="my-2 flex-fill">{t("language") === "en" ? item.name : item.nameEn}</div>
            <div className="my-2 mx-1">
              <span>{(item.price * item.quantity).toFixed(2)}</span>
              <span className="text-muted mx-1" style={{ fontSize: 12 }}>
                {t("SAR")}
              </span>
            </div>
          </div>
        </div>
      </div>

      {_renderOptions()}

      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
    </div>
  );
};

export default CartItem;
